import gql from "graphql-tag";

export const TranslationInfoFragment = gql`
  fragment TranslationInfo on Translation {
    lang
    text
  }
`;

export const CategoryInfoFragment = gql`
  fragment CategoryInfo on Category {
    _id
    code
    translations {
      ...TranslationInfo
    }
  }
  ${TranslationInfoFragment}
`;

export const ProductInfoFragment = gql`
  fragment ProductInfo on Product {
    _id
    code
    clientId
    name
    description
    category {
      ...CategoryInfo
    }
    reference
    weight
    volume
    value
    photoUrl
  }
  ${CategoryInfoFragment}
`;
